import "./stats.css"
import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import Chart from "react-apexcharts"
import { FaCoins, FaCalendarAlt, FaUsers, FaChartBar, FaTrophy } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

const d = new Date();


class AdminStatStars extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected_action: 0,
            actions_info: {},
            period_average: {},
            stars_daily_average: {},
            stars_daily_stats: {},
            end_date: new Date().toISOString().substring(0, 10),
            start_date: new Date(d.setMonth(new Date().getMonth() - 1)).toISOString().substring(0, 10),
            options_stars: null,
            series_star: null,
            current: {}
        }
    }

    componentDidMount = async () => {
        await this.loadStats()
    }

    loadStats = async () => {
        const stars = await AdminService.getStarsUsage(this.state.start_date, this.state.end_date, this.state.selected_action)
        const actions_by_player = [], nb_actions = [], nb_players = [], nb_stars = [], stars_by_action = [], stars_by_player = []
        Object.keys(stars.daily_stats).map(key => actions_by_player.push(stars.daily_stats[key].actions_by_player))
        Object.keys(stars.daily_stats).map(key => nb_actions.push(stars.daily_stats[key].nb_actions))
        Object.keys(stars.daily_stats).map(key => nb_players.push(stars.daily_stats[key].nb_players))
        Object.keys(stars.daily_stats).map(key => nb_stars.push(stars.daily_stats[key].nb_assets))
        Object.keys(stars.daily_stats).map(key => stars_by_action.push(stars.daily_stats[key].assets_by_action))
        Object.keys(stars.daily_stats).map(key => stars_by_player.push(stars.daily_stats[key].assets_by_player))
        this.setState({
            actions_info: stars.actions_info,
            period_average: stars.period_average,
            stars_daily_average: stars.daily_average,
            stars_daily_stats: stars.daily_stats,
            options_stars: { chart: { id: "stars-bar" }, xaxis: { categories: Object.keys(stars.daily_stats) } },
            actions_by_player: [{ name: "stars", data: actions_by_player }],
            nb_actions: [{ name: "stars", data: nb_actions }],
            nb_players: [{ name: "stars", data: nb_players }],
            nb_stars: [{ name: "stars", data: nb_stars }],
            stars_by_action: [{ name: "stars", data: stars_by_action }],
            stars_by_player: [{ name: "stars", data: stars_by_player }],
            current: stars.stars.current,
        })
    }

    render() {
        return (
            <AdminLayout 
                title="Coins Statistics"
                breadcrumbs={[
                    { label: 'Statistics', href: '/admin/stats' },
                    { label: 'Coins' }
                ]}
            >
                <div className="space-y-6">
                    {/* Page Header with Gradient */}
                    <div className="bg-gradient-to-r from-amber-400 via-yellow-500 to-amber-500 rounded-xl shadow-lg p-6 text-white">
                        <div className="flex items-center justify-between flex-wrap gap-4">
                            <div className="flex items-center gap-4">
                                <div className="p-4 bg-white/20 rounded-xl backdrop-blur-sm">
                                    <FaCoins className="text-4xl" />
                                </div>
                                <div>
                                    <h2 className="text-3xl font-bold">Coins Analytics</h2>
                                    <p className="text-white/90 mt-1">Monitor star distribution and usage patterns</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Date Range Filters */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                        <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                            <FaCalendarAlt className="text-amber-600" />
                            Date Range
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Start Date</label>
                                <input 
                                    type="date" 
                                    value={this.state.start_date} 
                                    onChange={(e) => this.setState({ start_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all"
                                />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">End Date</label>
                                <input 
                                    type="date" 
                                    value={this.state.end_date} 
                                    onChange={(e) => this.setState({ end_date: e.target.value }, () => this.loadStats())}
                                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all"
                                />
                            </div>
                        </div>
                    </div>

                    {/* Current Statistics - Key Metrics Cards */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        <div className="bg-gradient-to-br from-amber-50 to-yellow-50 rounded-xl shadow-md border border-amber-200 p-6">
                            <div className="flex items-center justify-between mb-4">
                                <div className="p-3 bg-amber-100 rounded-lg">
                                    <FaCoins className="text-2xl text-amber-600" />
                                </div>
                                <div className="text-right">
                                    <p className="text-sm text-gray-600">Active Coins</p>
                                    <p className="text-3xl font-bold text-amber-600">{this.state.current.active_stars_by_player || 0}</p>
                                    <p className="text-xs text-gray-500 mt-1">per player</p>
                                </div>
                            </div>
                            <div className="pt-4 border-t border-amber-200">
                                <p className="text-sm text-gray-700">Total Supply: <span className="font-bold text-amber-700">{this.state.current.active_supply || 0}</span></p>
                            </div>
                        </div>

                        <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-xl shadow-md border border-blue-200 p-6">
                            <div className="flex items-center justify-between mb-4">
                                <div className="p-3 bg-blue-100 rounded-lg">
                                    <FaUsers className="text-2xl text-blue-600" />
                                </div>
                                <div className="text-right">
                                    <p className="text-sm text-gray-600">Active Players</p>
                                    <p className="text-3xl font-bold text-blue-600">{this.state.current.nb_active_players || 0}</p>
                                    <p className="text-xs text-gray-500 mt-1">with stars</p>
                                </div>
                            </div>
                            <div className="pt-4 border-t border-blue-200">
                                <p className="text-sm text-gray-700">Total Players: <span className="font-bold text-blue-700">{this.state.current.total_players || 0}</span></p>
                            </div>
                        </div>

                        <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl shadow-md border border-purple-200 p-6">
                            <div className="flex items-center justify-between mb-4">
                                <div className="p-3 bg-purple-100 rounded-lg">
                                    <FaTrophy className="text-2xl text-purple-600" />
                                </div>
                                <div className="text-right">
                                    <p className="text-sm text-gray-600">Total Stars</p>
                                    <p className="text-3xl font-bold text-purple-600">{this.state.current.total_stars_by_player || 0}</p>
                                    <p className="text-xs text-gray-500 mt-1">per player</p>
                                </div>
                            </div>
                            <div className="pt-4 border-t border-purple-200">
                                <p className="text-sm text-gray-700">Total Supply: <span className="font-bold text-purple-700">{this.state.current.total_supply || 0}</span></p>
                            </div>
                        </div>
                    </div>

                    {/* Action Filter */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6">
                        <label className="block text-sm font-medium text-gray-700 mb-3 flex items-center gap-2">
                            <FaChartBar className="text-amber-600" />
                            Filter by Action Type
                        </label>
                        <select 
                            value={this.state.selected_action}
                            onChange={(e) => this.setState({ selected_action: e.target.value }, () => this.loadStats())}
                            className="w-full md:w-auto min-w-[300px] px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none transition-all bg-white"
                        >
                            {Object.keys(this.state.actions_info).map(key =>
                                <option key={key} value={key}>{this.state.actions_info[key]}</option>
                            )}
                        </select>
                    </div>

                    {/* Period Statistics */}
                    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
                        <div className="bg-gradient-to-r from-amber-50 to-yellow-50 px-6 py-4 border-b border-gray-200">
                            <h4 className="font-semibold text-gray-900 text-lg">Period Statistics Breakdown</h4>
                        </div>
                        <div className="overflow-x-auto">
                            <table className="w-full">
                                <thead className="bg-gray-50">
                                    <tr>
                                        <th colSpan={3} className="px-6 py-4 text-center text-sm font-semibold text-gray-700 border-r border-gray-200">
                                            <div className="flex items-center justify-center gap-2">
                                                <FaChartBar className="text-blue-600" />
                                                Daily Average
                                            </div>
                                        </th>
                                        <th colSpan={3} className="px-6 py-4 text-center text-sm font-semibold text-gray-700">
                                            <div className="flex items-center justify-center gap-2">
                                                <FaChartBar className="text-purple-600" />
                                                Period Average
                                            </div>
                                        </th>
                                    </tr>
                                    <tr className="bg-gray-100 border-t border-gray-200">
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Nb Actions</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Nb Players</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase border-r border-gray-200">Nb Stars</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Actions/Player</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Stars/Action</th>
                                        <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Stars/Player</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="hover:bg-amber-50 transition-colors">
                                        <td className="px-6 py-4 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                                                <span className="text-lg font-bold text-gray-900">{this.state.stars_daily_average.nb_actions || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-cyan-500"></div>
                                                <span className="text-lg font-bold text-gray-900">{this.state.stars_daily_average.nb_players || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 border-r border-gray-200">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-amber-500"></div>
                                                <span className="text-lg font-bold text-amber-600">{this.state.stars_daily_average.nb_assets || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                                                <span className="text-lg font-bold text-gray-900">{this.state.period_average.actions_by_player || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4 border-r border-gray-100">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-pink-500"></div>
                                                <span className="text-lg font-bold text-gray-900">{this.state.period_average.assets_by_action || 0}</span>
                                            </div>
                                        </td>
                                        <td className="px-6 py-4">
                                            <div className="flex items-center gap-2">
                                                <div className="w-2 h-2 rounded-full bg-amber-500"></div>
                                                <span className="text-lg font-bold text-amber-600">{this.state.period_average.assets_by_player || 0}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* Charts Grid */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaChartBar className="text-amber-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Actions by Player</h4>
                            </div>
                            {this.state.actions_by_player && <Chart options={this.state.options_stars} series={this.state.actions_by_player} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaChartBar className="text-blue-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Number of Actions</h4>
                            </div>
                            {this.state.nb_actions && <Chart options={this.state.options_stars} series={this.state.nb_actions} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaUsers className="text-cyan-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Number of Players</h4>
                            </div>
                            {this.state.nb_players && <Chart options={this.state.options_stars} series={this.state.nb_players} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaCoins className="text-amber-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Number of Stars</h4>
                            </div>
                            {this.state.nb_stars && <Chart options={this.state.options_stars} series={this.state.nb_stars} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaTrophy className="text-purple-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Stars by Action</h4>
                            </div>
                            {this.state.stars_by_action && <Chart options={this.state.options_stars} series={this.state.stars_by_action} type="bar" height={300} />}
                        </div>

                        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 hover:shadow-lg transition-shadow">
                            <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200">
                                <FaUsers className="text-pink-600 text-lg" />
                                <h4 className="text-lg font-semibold text-gray-900">Stars by Player</h4>
                            </div>
                            {this.state.stars_by_player && <Chart options={this.state.options_stars} series={this.state.stars_by_player} type="bar" height={300} />}
                        </div>
                    </div>
                </div>
            </AdminLayout>
        )
    }
}

export default withTranslation()(AdminStatStars)